import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import moment from "moment";

import { fetchEarnedPoints } from "../../redux/slice/earnedPoints";
import { formatIndianNumber } from "../../utils/common";

import "./PointHistory.scss";
import NoDataComp from "../../component/NoDataComp";
import Spinner from "../../component/spinner/Spinner";
import gold_rupe_icon_md from "../../assets/images/gold_rupe_md.svg";
import hotel_Icon from "../../assets/images/transctionIcon.svg";
// import clockIcon from "../../assets/images/last_minute_deal.svg";


const RedeemedPoints = ({ filteredRedeemedPoints }) => {
  // const { redeemedPointsData } = useSelector((state) => state.earnedPoints);
  const dispatch = useDispatch();
  const { earnedPointsData, loading } = useSelector(
    (state) => state.earnedPoints
  );

  useEffect(() => {
    if (earnedPointsData?.length === 0) {
      dispatch(fetchEarnedPoints());
    }
    // eslint-disable-next-line 
  }, []);

  return (
    <>
    <div className="tabTable">
      <div className="border_bottom_section">
        {filteredRedeemedPoints?.length > 0
          ? filteredRedeemedPoints.map((item) => {
              return (
                <React.Fragment key={item?.id}>
                  <div className="d-flex justify-content-between transction_list redeem">                  
                    <div className="hotel_booking_details d-flex align-items-center">
                      {/* <img className="hotel_Icon_div" src={hotel_Icon} alt="" /> */}
                      <div>
                        {/* <p> Shopping</p> */}
                        <h1>{item?.notes}</h1>
                        {/* <div className="date_expire">
                          <img src={clockIcon} alt="" /> Expires on, --
                        </div> */}
                      </div>
                    </div>
                    <div className="bookingStatus desktop_content">
                      <p>
                        {" "}
                        Uploaded on :{" "}
                        <span className="high_light_text">
                          {" "}
                          {moment(item?.redeemed_time).format("Do MMMM")}
                        </span>
                      </p>
                      {/* <p className="coinStatus">Coins yet to earn</p> */}
                    </div>
                    <div className="points_gold">
                      <p className="high_light_text" style={{display: "flex"}}>
                        -{formatIndianNumber(item?.points_redeemed)}{" "}
                        <img src={gold_rupe_icon_md} alt="" />
                      </p>
                    </div>
                  </div>
                </React.Fragment>
              );
            })
          : (loading ? null : <NoDataComp />)}
      </div>
    </div>
    {loading ? (
        <div className="spinner_table_height">
          <Spinner color="black" />
        </div>
      ) : null}
              </>
  );
};

export default RedeemedPoints;
